import { render, staticRenderFns } from "./batch-details.vue?vue&type=template&id=0992d8f8&scoped=true&"
import script from "./batch-details.vue?vue&type=script&lang=ts&"
export * from "./batch-details.vue?vue&type=script&lang=ts&"
import style0 from "./batch-details.vue?vue&type=style&index=0&id=0992d8f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0992d8f8",
  null
  
)

export default component.exports